import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,
	CCol,
	CCard,CCardHeader,CCardBody,CCardFooter,
	CForm,CFormInput,CFormSelect,CInputGroup,CInputGroupText,CButton,
	//CImage,
	CLink,
	CTooltip,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import {
	MyPagination,
	MyDialogform,
	MyDialoglookup,
	MyPage500,
} from '../components/index'
import XLSX from "sheetjs-style";
import * as FileSaver from "file-saver";
import { Konfirm } from '../helpers/onConfirm'
import { UFunc,cBulanPanjang,cBulanPendek } from '../helpers/functions'
//import NumberFormat from 'react-number-format';

const pjson 		= require('../../package.json')
const Lapmutasistok 	= (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif,
	} = props; 

	//--DOM--/
	const uNavigate 			= useNavigate();
	const uDispatch 			= useDispatch();
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettinguserObj 			= useSelector(state => state.gListUserSetting);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uMaxData					= isMobile ? (uSettinguserObj.jml_mobile || 50) : (uSettinguserObj.jml_laporan || 100);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uIsHapusallow				= (uTokenObj.userhak==="SUPERADMIN"||uTokenObj.userhak==="PENGELOLA");// ? true : false;
	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uHtml500msg,setHtml500msg]	= React.useState(); 
	const [uTimeelapse,setTimeelapse]	= React.useState(0); 
	
	const uHeaderActionObj  	= useSelector(state => state.gInitHeaderAction);
	const uHandelFilter			= uHeaderActionObj.isHeaderFilter || false;
	const uHandelReset 			= uHeaderActionObj.isHeaderReset || false;

	//--DATA_TABEL--/
	//const uKeywordObj					= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const [uJmlData,setJmlData]			= React.useState(0);
	const [uPageActive,setPageActive]	= React.useState(1);
	const [uJmlHal,setJmlHal]			= React.useState(1);
	const [uDatamainArr,setDatamainArr]	= React.useState([]);
	const [uRowselect,setRowselect]		= React.useState(-1);
	const [uFirstload,setFirstload]		= React.useState("YA");
	const [uDataselect,setDataselect]	= React.useState({});
	const [uDataloadedObj,setDataloadedObj]	= React.useState();
	const [uTitelObj,setTitelObj]			= React.useState({});
	const [uSortingObj,setSortingObj]		= React.useState({});
	const uSettingsystemObj		= useSelector(state => state.gSystemsetting);
	const uHTMLstyleTabel		= useSelector(state => state.gHTMLstyleLaporan);

	const uDatacabangArr	= JSON.parse(localStorage.getItem("cabanglist")||"[]")

	const uCabandIDtokenArr	= ((uTokenObj||{}).usercabangid || "").split(",");
	const uCabangallowedArr = uTokenObj.userhak === "SUPERADMIN" ? uDatacabangArr
		: uDatacabangArr.filter(vItems => uCabandIDtokenArr.includes(vItems.id.toString()));

	const [uDatabarangArr,setDatabarangArr]		= React.useState([]);
	const [uDatadefaultArr,setDatadefaultArr]	= React.useState([]);
	//--END DATA_TABEL--/

	//--DLG_FORM--/
	const [uISDlgformshow,setDlgformshow]	= React.useState(false);
	const [uDlgformheader,setDlgformheader]	= React.useState("");
	const [uDlgforminputObj,setDlgforminputObj]= React.useState({});
	//--END DLG_FORM--/

	//--DLG_VIEW--/
	//--END DLG_VIEW--/

	//--DLG_LOOKUP--/
	const [uISDlglookupshow,setDlglookupshow]= React.useState(false)
	const [uDlglookupObj,setDlglookupObj]	= React.useState({})
	//--END DLG_LOOKUP--/

	//--DOM_VARS--/
	const uElJmlData		= document.getElementById("idjmldata");
	const uElJmlmobile		= document.getElementById("idjmldatamobile");
	const uFrameExport 		= document.getElementById("ifmcontentstoprint");
	const fileType 			= "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
	const fileExtension 	= ".xlsx";
	//--END DOM_VARS--/

	//--HANDEL--/
	const hdlKlikBaranglookup = () => {
		uDlgforminputObj.barang_caption 	= "";
		uDlgforminputObj.barang_id 			= "";

		uDlglookupObj.dlg_header	= "Lookup Data Barang";
		uDlglookupObj.inputvalue 	= "";
		uDlglookupObj.data_arr		= uDatabarangArr.map(vItems=>{
			return ({
				id: vItems.id,
				caption: vItems.nama_barang,
				caption_sub: vItems.nama_jenis,
			})
		});

		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0;if(_IDITEM <= 0) return;

		const vArridx = UFunc.getObjectIndeks(uDatabarangArr,_IDITEM);
		if(vArridx < 0) {
			setDlglookupshow(false); return;
		}

		uDlgforminputObj.barang_caption = uDatabarangArr[vArridx].caption_barang;
		uDlgforminputObj.barang_id 		= uDatabarangArr[vArridx].id;

		setDlglookupshow(false);

		let vTimeout = setTimeout(function(){
			clearTimeout(vTimeout)

			if(!isMobile) {
				const vElFocus	= document.getElementById("btnDialogSimpan")
				vElFocus && vElFocus.focus();
			}
		},350)
	}
	const hdlKlikDlgformsimpan = () => {
		let vElFocus = document.getElementById("inpcabangid");
		if((parseInt(uDlgforminputObj.cabang_id)||0) <= 0) {
			vElFocus && vElFocus.focus();
			showToast("Cabang Harus Dipilih !");return;
		}

		vElFocus 		= document.getElementById("inpbln");
		const vTanggals	= (uDlgforminputObj.thn+"-"+uDlgforminputObj.bln+"-01");
		const vTanggalDT = UFunc.toDate(vTanggals);
		if(!UFunc.DateIsValid(vTanggals)) {
			vElFocus && vElFocus.focus();
			showToast("Periode Tanggal/Bulan Tidak Valid !");return;
		}
		if(UFunc.DateIsBeyond(vTanggalDT)) {
			vElFocus && vElFocus.focus();
			showToast("Periode Tanggal/Bulan Belum Tercapai !");return;
		}
		if(parseInt(uDlgforminputObj.barang_id||0) < 0) {
			vElFocus && vElFocus.focus();
			showToast("Nama Barang Tidak Valid !");return;
		}

		apiLoadview();
	}
	const hdlKlikSorting = (_NAMAFIELD) => {
		_NAMAFIELD 			= (_NAMAFIELD || "").trim();
		const vSortnamenow	= uSortingObj.nama || "";
		const vSortjenis	= (uSortingObj.jenis||"").toUpperCase();
		const vSortarget	= vSortjenis===""?"DESC"
			: (vSortjenis==="DESC" ? "ASC" : "");

		let vSortednew	= {}
		if(vSortnamenow !== _NAMAFIELD) {
			vSortednew = { nama: _NAMAFIELD, jenis: "DESC" }
		} else {
			if(vSortjenis === "ASC") vSortednew = {}
			else vSortednew = { nama: _NAMAFIELD, jenis: vSortarget }
		}
		setSortingObj(vSortednew);
		setEfekview(!uEfekview);
	}
	const hdlKlikCetak = () => {
		if(uJmlData <= 0) return;

		let vContent 	= contentHTMLcetak();
		let pri 		= uFrameExport.contentWindow;
		pri.document.open();
		pri.document.write(vContent);
		pri.document.close();
		pri.focus();
		pri.print();
	}
	const hdlKlikExcel = () => {
		if(uJmlData <= 0) return;

		const vBarangID	= parseInt((uDataloadedObj||{}).barang_id)||"0";
		const vBulanID	= parseInt((uDataloadedObj||{}).bln)||"0";
		const vTahun	= parseInt((uDataloadedObj||{}).thn)||"0";

		const vColspan 	= 6;

		let vDatasetsArr 	= [];
		let vRowcount		= 0;
		let vColposwidth	= 50;

		let vTmpObj	= vBarangID > 0 ? ({
			no : "",
			tanggal: "",
			keterangan: "",
			status_mutasi: "",
			jml_mutasi: "",
			jml_saldo: "",
		}) : ({
			no : "",
			nama_barang: "",
			jml_before: "",
			jml_masuk: "",
			jml_keluar: "",
			jml_sisa: "",
		})
		vDatasetsArr.push(vTmpObj);

		vRowcount++;
		uDatamainArr.map((vItems,vKeys)=>{
			const {
				id,tanggal,nama_barang,jml_before,jml_masuk,jml_keluar,jml_sisa,
				keterangan,status_mutasi,jml_mutasi,jml_saldo,
			} = vItems;

			vRowcount++;
			if(vBarangID > 0)
				vColposwidth = (keterangan||"").length > vColposwidth 
					? (keterangan||"").length : vColposwidth; 
			else
				vColposwidth = (nama_barang||"").length > vColposwidth 
					? (nama_barang||"").length : vColposwidth; 

			const vTanggalDT	= UFunc.toDate(tanggal);
			vTmpObj	= vBarangID > 0 ? ({
				no : {v:vKeys+1,t:"n"},
				tanggal: vKeys > 0 ? {v:vTanggalDT,t:"d",s:{alignment:{horizontal:"left"}}} : {v:"-"},
				keterangan: {v:(keterangan||"-"),t:"s",s:{wrapText:true,}},
				status_mutasi: {v: vKeys > 0 ? (status_mutasi||"-"): "-",t:"s",s:{alignment:{horizontal:"center"}}},
				jml_mutasi: vKeys > 0 ? { v:parseFloat(jml_mutasi), t:"n", s:{numFmt: "#,##0"} } : {v:"-"},
				jml_saldo: { v:parseFloat(jml_saldo), t:"n", s:{numFmt: "#,##0"} },
			}) : ({
				no : {v:vKeys+1,t:"n"},
				nama_barang: {v:(nama_barang||"-"),t:"s",s:{wrapText:true}},
				jml_before: { v:parseFloat(jml_before), t:"n", s:{numFmt: "#,##0"} },
				jml_masuk: { v:parseFloat(jml_masuk), t:"n", s:{numFmt: "#,##0"} },
				jml_keluar: { v:parseFloat(jml_keluar), t:"n", s:{numFmt: "#,##0"} },
				jml_sisa: { v:parseFloat(jml_sisa), t:"n", s:{numFmt: "#,##0"} },
			}) 
			vDatasetsArr.push(vTmpObj);
		});

		//--SUM_NILAI--/
		//--END SUM_NILAI--/

		const wsrows	= [{hpt:43}]
		const wscols	= vBarangID > 0 ? [
			{wpx:40},
			{wpx:100},
			{wch:vColposwidth},
			{wpx:100},
			{wpx:85},
			{wpx:85},
		] : [
			{wpx:40},
			{wch:vColposwidth},
			{wpx:100},
			{wpx:85},
			{wpx:85},
			{wpx:100},
		];
		
		const wsmerge	= [
			{s:{r:0,c:0},e:{r:0,c:vColspan - 1}},
		]

		const vTanggalnowDT	= new Date()
		const vNamafile = 
			vTanggalnowDT.getFullYear()+
			UFunc.leadZero(vTanggalnowDT.getMonth()+1)+
			UFunc.leadZero(vTanggalnowDT.getDate())+"_LAPMUTASISTOK_"+
			(cBulanPendek[vBulanID-1]).toUpperCase()+vTahun+
		"";
		const vSheetlabel = (cBulanPendek[vBulanID-1])+vTahun;

		const ws 		= XLSX.utils.json_to_sheet(vDatasetsArr);
		//--CUSTOM_HEADER--/
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]+
			"\r\nPeriode "+uTitelObj.periode+
			(uTitelObj.subtitel ? "\r\n"+uTitelObj.subtitel : '')+
		"";
		const vHeaderArr = vBarangID > 0
			? [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Tanggal",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Keterangan",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Status Mutasi",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Jumlah",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Jml Saldo",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			] : [
			{v:"No",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Nama Barang",s:{alignment:{horizontal:"left"},font:{bold:true}}}, 
			{v:"Bln Lalu",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Jml Masuk",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Jml Keluar",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			{v:"Jml Sisa",s:{alignment:{horizontal:"center"},font:{bold:true}}}, 
			];

		XLSX.utils.sheet_add_aoa(ws, [[{v:vJudullaporan,t:"s",s:{
			alignment:{horizontal:"center",wrapText: true},
			font:{bold:true} 
		}}]], { origin: "A1" });
		XLSX.utils.sheet_add_aoa(ws, [vHeaderArr], { origin: "A2" });
		//--END CUSTOM_HEADER--*/
		ws['!rows'] 	= wsrows;
		ws['!cols'] 	= wscols;
		ws["!merges"] 	= wsmerge;

		const wb 		= { Sheets: { [vSheetlabel]: ws }, SheetNames: [vSheetlabel] };
		const excelBuffer = XLSX.write(wb, { bookType: "xlsx", bookSST: true, type: "array" });
		const data 		= new Blob([excelBuffer], { type: fileType });
		FileSaver.saveAs(data, vNamafile + fileExtension);
	}
	//--END HANDEL--/

	//--INIT--/
	const initFormreset = () => {
		setDataselect({})
		setDlgforminputObj({});
		setEfekview(!uEfekview);
	}
	const prosesReset = async() => {
		const vFuncnext = () => {
			setDataloadedObj();
			setDatamainArr([]);
			setEfekview(!uEfekview);
		}

		if(uDataloadedObj) {
			if(await Konfirm("Apakah Anda Yakin Akan Reset Laporan ?")) vFuncnext();
		} else {
			apiLoadinit();
		}
	}
	const initSUMdata = () => {
		uDataloadedObj && (
			uDataloadedObj.sum_bayar = (uDatamainArr||[]).reduce((vSums,vItems)=>{
				return vSums + (parseFloat(vItems.nilai_bayar)||0)
			},0)
		);
	}
	//--END INIT--/

	//--CONTENT--/
	const contentMain = () => {
		if(uHtml500msg) return ""

		if(uDataloadedObj && uJmlData <= 0) return (
			<div className="m-2 p-2 m-lg-5 p-lg-5 text-center fst-italic text-primary">
			&middot;&middot; Maaf, Data Tidak Ditemukan.. &middot;&middot;
			</div>
		)//>

		if((parseInt(uDataloadedObj.barang_id)||0) > 0) return contentPerbarang();
		if((parseInt(uDataloadedObj.barang_id)||0) <= 0) return contentSemuabarang();

		return ""
	}
	const contentPerbarang = () => {
		if((parseInt(uDataloadedObj.barang_id) ||0) <= 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);
		const vColspan		= 6;

		const vDataviewArr	= uDatamainArr.slice(vMin,vMax);

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabellaporan">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width="5%" className="">No</th>
			<th className="text-start" width="11%">{uBahasaObj.word_tanggal||"Tanggal"}</th>
			<th className="text-start">{uBahasaObj.word_keterangan||"Keterangan"}</th>
			<th className="" width="15%">{uBahasaObj.caption_statusmutasi||"Status Mutasi"}</th>
			<th className="" width="10%">{uBahasaObj.word_jumlah||"Jumlah"}</th>
			<th className="" width="13%">{uBahasaObj.caption_jmlsaldo||"Jml Saldo"}</th>
			</tr>
			<tr className="d-none"><th colSpan={vColspan}>{JSON.stringify(vDataviewArr)}</th></tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys)=>{
			const {
				id,tanggal,keterangan,status_mutasi,jml_mutasi,
				jml_saldo,
			} = vItems;

			vNumber++;

			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top "+(uRowselect===vKeys?"classrowselect":"")}>
			<td className="text-end mx-1">{vNumber}.</td>
			<td className="mx-1 text-start">
				{UFunc.isEmpty(tanggal) ? "-" : UFunc.TglAngka(tanggal)}
			</td>
			
			<td className="mx-1 text-start">
				{!UFunc.isEmpty(tanggal) ? (keterangan||"-") : (
					<span className="text-muted fst-italic">{keterangan||"-"}</span>
				)}
			</td>
			
			<td className="mx-1 text-center">
				{UFunc.isEmpty(tanggal) ? (<>&middot;</>) : (
					<>
					{(status_mutasi||"")==="MASUK" ? (
						<span className="text-primary">{status_mutasi}</span>
					) : (
						<span className="text-warning">{status_mutasi||"-"}</span>
					)}
					</>
				)}
			</td>

			<td className="mx-1 text-center">
				{UFunc.isEmpty(tanggal) ? (<>&middot;</>) : UFunc.formatAngka(jml_mutasi)}
			</td>

			<td className="mx-1 text-center">
				{(parseInt(jml_saldo)||0) >= 0 ? UFunc.formatAngka(jml_saldo)
					: (<span className="text-danger">-({UFunc.formatAngka(Math.abs(jml_saldo))})</span>)}
			</td>
			</tr>
			);
		})}
		</tbody>
		</table>
		)//>
	}
	const contentSemuabarang = () => {
		if((parseInt(uDataloadedObj.barang_id) ||0) > 0) return ""

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);
		const vColspan		= 6;

		const vDataviewArr	= uDatamainArr.slice(vMin,vMax);

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabellaporan">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width="5%" className="">No</th>
			<th className="text-start">{uBahasaObj.caption_namabarang||"Nama Barang"}</th>
			<th className="" width="15%">{uBahasaObj.caption_jmlblnlalu||"Bln Lalu"}</th>
			<th className="" width="12%">{uBahasaObj.caption_jmlmasuk||"Jml Masuk"}</th>
			<th className="" width="12%">{uBahasaObj.caption_jmlkeluar||"Jml Keluar"}</th>
			<th className="" width="15%">
				<span className={"me-1"+((uSortingObj.nama||"")==="jml_sisa" ? " text-danger" : "")}>
				{uBahasaObj.caption_sisablnini||"Sisa Bln Ini"}
				<span className="mx-1">&middot;</span>
				<CLink onClick={()=>hdlKlikSorting("jml_sisa")} className="classcursorpointer">
				<CIcon icon={((uSortingObj.nama||"")==="jml_sisa" && (uSortingObj.jenis||"")==="ASC" ? "cilArrowTop" : "cilArrowBottom")}
					className="align-middle" height={20}/>
				</CLink>
				</span>
			</th>
			</tr>
			<tr className="d-none"><th colSpan={vColspan}>{JSON.stringify(vDataviewArr)}</th></tr>
		</thead>

		<tbody>
		{vDataviewArr.map((vItems,vKeys)=>{
			const {
				nama_barang,jml_before,jml_masuk,jml_keluar,jml_sisa,id
			} = vItems;

			vNumber++;

			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top "+(uRowselect===vKeys?"classrowselect":"")}>
			<td className="text-end mx-1">{vNumber}.</td>
			<td className="mx-1 text-start">{nama_barang}</td>
			<td className="mx-1 text-center fw-bolder">
				{(parseInt(jml_before)||0) < 0 ? (
					<span className="text-danger">-({UFunc.formatAngka(Math.abs(jml_before))})</span>
				) : UFunc.formatAngka(jml_before)}
			</td>
			<td className="mx-1 text-center text-success">{UFunc.formatAngka(jml_masuk)}</td>
			<td className="mx-1 text-center text-warning">{UFunc.formatAngka(jml_keluar)}</td>
			<td className="mx-1 text-center fw-bolder text-primary">
				{(parseInt(jml_sisa)||0) < 0 ? (
					<span className="text-danger">-({UFunc.formatAngka(Math.abs(jml_sisa))})</span>
				) : UFunc.formatAngka(jml_sisa)}
			</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		const vJmlTahunlaporan	= parseInt(uSettingsystemObj.jml_tahun_laporan)||5;

		return (
		<CForm className="">
		<CRow className="my-2">
		<CCol xs="4" className="text-start">{uBahasaObj.word_cabang||"Cabang"}</CCol>
		<CCol className="text-end">
			<CFormSelect size="sm"
				value={uDlgforminputObj.cabang_id}
				onChange={(e)=>{uDlgforminputObj.cabang_id=e.target.value;setEfekview(!uEfekview)}}
				id="inpcabangid">
			{uCabangallowedArr.map((vItems,vKeys)=>{
				return (
				<option key={vKeys} value={vItems.id}>{vItems.nama_cabang}</option>
				)
			})}
			</CFormSelect>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4" className="text-start">
			{(uBahasaObj.word_bulan||"Bulan")}
		</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			<CFormSelect size="sm"
				value={uDlgforminputObj.bln}
				onChange={(e)=>{uDlgforminputObj.bln=e.target.value;setEfekview(!uEfekview)}}
				id="inpbln">
				{cBulanPanjang.map((vItems,vKeys)=>{
					return(
					<option key={vKeys} value={UFunc.leadZero(vKeys+1)}>{vItems.toUpperCase()}</option>
					)
				})}
			</CFormSelect>
			<span className="mx-1 d-none d-lg-block"/>
			<CFormSelect size="sm"
				value={uDlgforminputObj.thn}
				onChange={(e)=>{uDlgforminputObj.thn=e.target.value; setEfekview(!uEfekview)}}
				id="inpthn">
				{(() => {
					let vTmpArr 	= [];
					const vTahunnow	= (new Date()).getFullYear();
					for(var vIdx=0;vIdx < vJmlTahunlaporan;vIdx++) {
						vTmpArr.push(
						<option value={(vTahunnow - vIdx)} key={vIdx}>{(vTahunnow - vIdx)}</option>
						)
					}
					return vTmpArr;
				})()}
			</CFormSelect>
			</CInputGroup>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4" className="text-start">{uBahasaObj.caption_pilihbarang||"Pilih Barang"}</CCol>
		<CCol className="text-end">
			<CInputGroup size="sm">
			<CFormInput size="sm" readOnly={true}
				placeholder="--SEMUA BARANG--"
				value={uDlgforminputObj.barang_caption}
				onChange={(e)=>{uDlgforminputObj.barang_caption = e.target.value;setEfekview(!uEfekview)}}
				onClick={()=>hdlKlikBaranglookup()}
				id="inpbaranglookup"/>
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikBaranglookup()}
				id="btnBaranglookup">
			<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
		</CCol>
		</CRow>
		</CForm>
		)//>
	}
	const contentHTMLcetak = () => {
		let vHTMLs	= uHTMLstyleTabel;

		//console.log("(Lapkasir - contentHTMLcetak) uDataidentitasObj => "+(uDataidentitasObj));

		const vColspan 		= 6;
		const vDataviewArr	= uDatamainArr;
		const vBarangID		= parseInt(uDataloadedObj.barang_id)||0;
		const vCabangidx	= UFunc.getObjectIndeks(uDatacabangArr,uDataloadedObj.cabang_id);

		vHTMLs	+= UFunc.RenderTabel(vColspan);
		
		const vJudullaporan = uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()];
		const vJudulsub		= `
			<div>Periode <b>`+uTitelObj.periode+`</b> (`+uTitelObj.cabang+`)</div>`+
			(uTitelObj.subtitel ? `<div>`+uTitelObj.subtitel+`</div>` : ``)+`
		`;

		const vTabelheader	= 
			vBarangID > 0
			? `
			<th width="5%">No</th>
			<th width="11%" align="left">`+(uBahasaObj.word_tanggal||"Tanggal")+`</th>
			<th align="left">Keterangan</th>
			<th width="13%">Status</th>
			<th width="10%">Jumlah</th>
			<th width="10%">Saldo</th>
			</tr>
			`
			: `
			<th width="5%">No</th>
			<th align="left">`+(uBahasaObj.caption_namabarang||"Nama Barang")+`</th>
			<th width="10%">Bln Lalu</th>
			<th width="10%">Jml Masuk</th>
			<th width="10%">Jml Keluar</th>
			<th width="10%">Sisa Saldo</th>
			</tr>
			`;
		
		let vTabelbody	= "";
		let vNumber		= 0;
		vDataviewArr.map((vItems,vKeys) => {
			const {
				id,tanggal,nama_barang,jml_before,jml_masuk,jml_keluar,jml_sisa,
				keterangan,status_mutasi,jml_mutasi,jml_saldo,
			} = vItems;
			vNumber++;

			vTabelbody += 
			vBarangID > 0
				? `
				<tr valign="top" key=`+vKeys+`>
				<td align="right">`+vNumber+`.</td>
				<td align="left">`+(vKeys <= 0 ? "-" : UFunc.TglAngka(tanggal) )+`</td>
				<td align="left">`+(keterangan||"-")+`</td>
				<td align="center">`+(vKeys <= 0 ? "-" : (status_mutasi||"-") )+`</td>
				<td align="center">`+(vKeys <= 0 ? "-" : UFunc.formatAngka(jml_mutasi) )+`</td>
				<td align="center">`+UFunc.formatAngka(jml_saldo)+`</td>
				</tr>
				` : `
				<tr valign="top" key=`+vKeys+`>
				<td align="right">`+vNumber+`.</td>
				<td align="left">`+(nama_barang)+`</td>
				<td align="center">`+UFunc.formatAngka(jml_before)+`</td>
				<td align="center">`+UFunc.formatAngka(jml_masuk)+`</td>
				<td align="center">`+UFunc.formatAngka(jml_keluar)+`</td>
				<td align="center"><b>`+UFunc.formatAngka(jml_sisa)+`</b></td>
				</tr>
				`;
		}).join("");
		
		const vTabelfooter 	= ``;

		vHTMLs 		= vHTMLs.replace(/_TITELSUB_/g,vJudulsub);
		vHTMLs 		= vHTMLs.replace(/_JUDULLAPORAN_/g,vJudullaporan);
		vHTMLs 		= vHTMLs.replace(/_TABELHEADER_/g,vTabelheader);
		vHTMLs 		= vHTMLs.replace(/_TABELBODY_/g,vTabelbody);
		vHTMLs 		= vHTMLs.replace(/_TABELFOOTER_/g,vTabelfooter);

		return vHTMLs;
	}
	//--END CONTENT--/

	//--REST_API--/
	const apiLoadinit = () => {
		setHtml500msg();
		setDatamainArr([]);
		setDataselect(0);
		setRowselect(-1);
		setPageActive(1);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTmpObj		= []
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_firstload : uFirstload,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_lapmutasistok/ld_init";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.tampil) {
				setDatabarangArr(JSON.parse(output_string.databarang||"[]"));
				
				if(uFirstload==="YA") setFirstload("TIDAK");
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapkasir - apiLoadinit) output_string.errors : "+output_string.errors);
				const vMsg	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(Lapkasir - apiLoadinit) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoadview = () => {
		setDataloadedObj();
		setDatamainArr([]);setDatadefaultArr([]);
		setDataselect({});
		setRowselect(-1);
		setPageActive(1);
		setSortingObj({});

		const vBtnsimpan	= document.getElementById("btnDialogSimpan");
		vBtnsimpan && (vBtnsimpan.disabled = true)
		setLoading(true)

		/*//--TESTING_FRONTEND--/
		console.log("(User - apiLoadview) LEWAT "); 
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
		},2000); return
		//--END TESTING_FRONTEND--*/

		const vTmpObj	= {
			cabang_id : uDlgforminputObj.cabang_id,
			bln : uDlgforminputObj.bln,
			thn : uDlgforminputObj.thn,
			barang_id : uDlgforminputObj.barang_id,
			barang_caption : uDlgforminputObj.barang_caption,
		}
		const vDATAS	= JSON.stringify({
			send_datajson : JSON.stringify(vTmpObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_lapmutasistok/ld_view";

		setTimeelapse(0);
		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			vBtnsimpan && (vBtnsimpan.disabled = false)
			if(output_string.tampil) {
				const vTmpArr = JSON.parse(output_string.dataview||"[]");
				setDatamainArr(vTmpArr);
				setDatadefaultArr([{init_change:"1"},...vTmpArr]);

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeelapse(vTimeDiff);

				setDataloadedObj(uDlgforminputObj);
				setDlgformshow(false);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Lapmutasistok - apiLoadview) output_string.errors : "+output_string.errors);
				const vMsg	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setDlgformshow(false); setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			vBtnsimpan && (vBtnsimpan.disabled = false)
			setLoading(false);
			console.log("(Lapmutasistok - apiLoadview) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END REST_API--/

	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

    	apiLoadinit();

    	return () => {
			uDispatch({type: "set", gInitHeaderAction: {}});
    		setDatamainArr([]); setDataloadedObj();setDatadefaultArr([]);
    		setFirstload("YA");setSortingObj({});
			setRowselect(-1);
			setPageActive(1);

			setDlgformshow(false); 
    	}
	},[])
	React.useEffect(()=>{
		if(!uHandelFilter) return;
		
		uHeaderActionObj.isHeaderFilter = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHtml500msg) return;

		uDlgforminputObj.dlg_header = "Filter Laporan Mutasi Stok";
		setDlgformshow(true);
	},[uHandelFilter])
	React.useEffect(()=>{
		//console.log("(Lapkasir-[isHeaderReset]) isHeaderReset = "+isHeaderReset)
		if(!uHandelReset) return;

		uHeaderActionObj.isHeaderReset = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		prosesReset();
	},[uHandelReset])
	React.useEffect(()=>{
		setJmlData(uDatamainArr.length);
		if(uDatamainArr.length <= 0) return;

		initSUMdata(); 
	},[uDatamainArr.length])
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal);//-*/
		setPageActive(uPageActive<=0?1:uPageActive);

		uElJmlData && (uElJmlData.innerHTML = UFunc.formatAngka(uJmlData));
		uElJmlmobile && (uElJmlmobile.innerHTML = UFunc.formatAngka(uJmlData));
	},[uJmlData])
	React.useEffect(()=>{ setRowselect(-1); },[uPageActive])//-->Unselect_ROW
	React.useEffect(()=>{
		const vEls 	= document.getElementById("btnFilter");
		if(!uISDlgformshow) { 
			initFormreset(); 
			vEls && (vEls.disabled = false);
			return; 
		}

		const vTglnowDT 	= new Date();
		if(uDlgforminputObj.cabang_id === undefined) {
			const vCabangid = localStorage.getItem("cabangidselect") || uCabangallowedArr[0].id;
			uDlgforminputObj.cabang_id = vCabangid;
		}
		if(uDlgforminputObj.bln === undefined) 
			uDlgforminputObj.bln = uDataloadedObj ? uDataloadedObj.bln : UFunc.leadZero(vTglnowDT.getMonth() + 1);
		if(uDlgforminputObj.thn === undefined) 
			uDlgforminputObj.thn = uDataloadedObj ? uDataloadedObj.thn : UFunc.leadZero(vTglnowDT.getFullYear(),4);
		if(uDlgforminputObj.barang_id === undefined) 
			uDlgforminputObj.barang_id = uDataloadedObj ? uDataloadedObj.barang_id : 0;
		if(uDlgforminputObj.barang_caption === undefined) 
			uDlgforminputObj.barang_caption = uDataloadedObj ? uDataloadedObj.barang_caption : "";

		vEls && (vEls.disabled = true);

		//console.log("("+cComponentName+"[uISDlgformshow]) uISDlgformshow 1: "+uISDlgformshow);
		let vTimeout = setTimeout(function(e){
			clearTimeout(vTimeout);
			const vElFocus = document.getElementById("inpcabangid");

			if(!isMobile) vElFocus && vElFocus.focus();
		},250);
	},[uISDlgformshow])
	React.useEffect(()=>{
		if(!uDataloadedObj) { setTitelObj({}); return }

		const vIdxcabang	= UFunc.getObjectIndeks(uDatacabangArr,uDataloadedObj.cabang_id);
		uTitelObj.cabang 	= uDatacabangArr[vIdxcabang].nama_cabang;
		uTitelObj.periode 	= cBulanPanjang[parseInt(uDataloadedObj.bln)-1]+" "+uDataloadedObj.thn;

		uTitelObj.subtitel 	= (parseInt(uDataloadedObj.barang_id)||0) < 0 ? "SEMUA BARANG" : uDataloadedObj.barang_caption;
	},[uDataloadedObj]);
	React.useEffect(()=>{
		if(uDatamainArr.length <= 0) return;
		if(uPageActive > 1) setPageActive(1);
		else { setRowselect(-1); setDataselect({}); }

		if(JSON.stringify(uSortingObj||{}) === "{}") { setDatamainArr(uDatadefaultArr.slice(1)); return; }

		//let vSortedArr	= [];
		const vNamasort = (uSortingObj.nama||"").toLowerCase();
		if(uSortingObj.jenis === "ASC") {
			uDatamainArr.sort((a, b) => a[vNamasort] - b[vNamasort]);
		}else if(uSortingObj.jenis === "DESC") {
			uDatamainArr.sort((a, b) => b[vNamasort] - a[vNamasort]);
		} else {
			const vDefaultsort = uDatadefaultArr.slice(1);
			setDatamainArr(vDefaultsort);//setEfekview(!uEfekview);
		}
	},[uSortingObj,
	uSortingObj.nama,
	uSortingObj.jenis,
	])
	//React.useEffect(()=>{ },[uDlgforminputObj])

	if(UFunc.isEmpty(uTokenObj)) { setLoading(true); prosesExpired(); return ""; }
	if(uHtml500msg)  return ( <MyPage500 content={uHtml500msg}/> )//>

	return (
		<>
		{(!uDataloadedObj) ? (
		<CCard className="classcardbg">
			<CCardHeader className="">
			<small className="fw-bolder">Pilih Filter Laporan</small>
			</CCardHeader>

			<CCardBody className="d-flex justify-content-center align-items-center" style={{minHeight:200}}>
			<div className="classpetunjuk">
			*) Silahkan Pilih Filter, untuk menentukan Parameter Laporan yang akan Ditampilkan. Kemudian Tekan SIMPAN. Untuk Mencetak Silahkan KLIK Ikon Cetak..
			</div>
			</CCardBody>
		</CCard>
		) : (
		<CCard className="classcardbg">
			<CCardHeader className="d-flex justify-content-between align-items-center">
			<div>
			<div className="">Periode <b>{uTitelObj.periode}</b> &middot; ({uTitelObj.cabang})</div>
			<small className="text-primary">{uTitelObj.subtitel}</small>
			</div>

			<div>
				<CLink onClick={()=>hdlKlikCetak()} className="classcursorpointer classikon classikoncetak"/>
				<span className="mx-1">&middot;</span>
				<CLink onClick={()=>hdlKlikExcel()} className="classcursorpointer classikon classikonexcel"/>
				<span className="mx-1">&middot;</span>
				<span className="classfontsmaller">
					<small className="text-muted">
						{UFunc.formatAngka(uTimeelapse)}ms
					</small>
				</span>
			</div>
			</CCardHeader>

			<CCardBody className="px-0">{contentMain()}</CCardBody>

			{(uJmlData > uMaxData) && (
			<CCardFooter>
			<MyPagination 
				activePage={uPageActive}
				pages={uJmlHal}
				onActivePageChange={(i)=>setPageActive(i)}
				align="start"/>
			</CCardFooter>
		)}
		</CCard>
		)}

		<MyDialogform
			options={{centered:true}}
			onSimpan={()=>hdlKlikDlgformsimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgforminputObj.dlg_header || ""}
			toggle={()=>setDlgformshow(false)}
			renderContent={contentDlgform()}/>

		<MyDialoglookup
			show={uISDlglookupshow} 
			dialogHeader={uDlglookupObj.dlg_header||""}
			toggle={()=>setDlglookupshow(false)}
			inputValue={uDlglookupObj.inputvalue||""}
			dataItemArr={uDlglookupObj.data_arr||[]}
			onKlikPilihItem={hdlKlikDlglookuppilih}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
		</>
	)//>
}	

export default Lapmutasistok